<template>
  <v-card
    :class="$vuetify.breakpoint.mobile ? 'flex-column pa-3' : 'mr-2 my-4 pa-1'"
    class="px-3"
    @click="goToDestination"
  >
    <div class="d-flex justify-center max-width pt-2">
      <div
        v-if="redirection.pictogramme"
        class="align-self-center"
      >
        <v-img
          :src="`/images/pictogrammes/${redirection.pictogramme.path}.svg`"
          alt="picto"
          class="picto mr-2"
        />
      </div>
      <div
        :class="$vuetify.breakpoint.mobile || !isOnTdb ? 'flex-column ml-3' : ''"
        class="d-flex align-self-center max-width"
      >
        <div
          v-if="redirection.nouveaute"
          :class="
            $vuetify.breakpoint.mobile || !isOnTdb ? '' : 'mx-3'
          "
        >
          <v-chip
            class="mb-1"
            color="#DBBD00"
            label
          >
            <span class="texte white--text">Nouveau</span>
          </v-chip>
        </div>
        <div
          class="align-self-center intro text-gris-fonce max-width"
        >
          {{ redirection.texte }}
        </div>
      </div>
      <div class="align-self-center">
        <v-icon class="ml-1">
          mdi-chevron-right
        </v-icon>
      </div>
    </div>

    <InfoModal
      v-if="isOpenModaleCulturesManquantes"
      confirm-text="Renseigner les infos"
      titre="Infos manquantes"
      :is-open-modale-infos-manquantes="isOpenModaleCulturesManquantes"
      @close="isOpenModaleCulturesManquantes = false"
      @confirm="toPageCulture()"
    >
      <CultureManquanteContentModal />
    </InfoModal>
  </v-card>
</template>

<script>
import { sum } from 'lodash'
import {mapActions, mapGetters} from 'vuex'
import Bowser from 'bowser'
import CultureManquanteContentModal from '@/views/cultures/components/modal/culture-manquante-content-modal.vue'
import InfoModal from '@/components/modal/info-modal.vue'

export default {
  name: 'AdherentRebond',
  components: {CultureManquanteContentModal, InfoModal},
  props: {
    redirection: {
      type: Object,
      required: true
    },
    pathOrigine: {
      type: String,
      required: true
    },
    isOnTdb: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isOpenModaleCulturesManquantes: false
    }
  },
  computed: {
    ...mapGetters({
      assolement: 'assolement/assolement',
      codeGraineActive: 'application/codeGraineActive',
      userProfil: 'user/profil'
    }),
    culturesSelected () {
      let result = []
      for (let i = 0; i < this.assolement.length; i++ ) {
        if (this.codeGraineActive !== null && this.assolement[i].codesRs3Correspondants.includes(this.codeGraineActive)) {
          result.push({ surface: this.assolement[i].surfaceEnHectare })
        }
      }
      return result
    },
    surfaceTotaleGraineSelected () {
      return sum(this.culturesSelected.flatMap(c => c.surface))
    },
  },
  methods: {
    ...mapActions({
      createRedirectionUtilisation : 'redirection/createRedirectionUtilisation'
    }),
    goToDestination () {
      const infoNavigateur = Bowser.getParser(window.navigator.userAgent).getResult()
      const redirectionUtilisation = {
        username: this.userProfil.username,
        dateRedirection: new Date(),
        pathPageOrigine: this.pathOrigine,
        typePlateforme: infoNavigateur.platform.type,
        redirection: this.redirection
      }
      this.createRedirectionUtilisation(redirectionUtilisation)
        .finally(() => {
          if (!this.surfaceTotaleGraineSelected>0 && this.redirection.pageDestination.pathFront === 'main.mes-outils-d-analyse') {
            this.isOpenModaleCulturesManquantes = true
          } else {
            this.$router.push({ name: this.redirection.pageDestination.pathFront})
          }
        })
    },
    toPageCulture () {
      this.isOpenModaleCulturesManquantes = false
      this.$router.push({ name: 'main.mes-cultures' })
    },
  }
}
</script>
<style lang="scss" scoped>
.max-width {
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
